import {
    List,
    ListItem,
    ListItemAvatar,
    Avatar,
    ListItemText,
    Chip,
    Box,
    Typography,
} from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { useTheme } from "@mui/material/styles";


export default function PopularQualifications({ popularQualifications }) {
    const theme = useTheme();

    if (!popularQualifications?.length) {
        return (
            <Box p={2}>
                <Typography variant="body2" color="text.secondary">
                    Brak danych
                </Typography>
            </Box>
        );
    }

    return (
        <List>
            {popularQualifications.map((qual) => (
                <ListItem
                    key={qual.id}
                    sx={{
                        borderRadius: 2,
                        border: '1px solid #294e6b2b',
                        backgroundColor:
                            theme.palette.mode === "dark"
                                ? theme.palette.background.main
                                : "rgba(255, 255, 255, 0.58)",
                        mb: 1,
                        // boxShadow: 1,
                    }}
                >
                    <ListItemAvatar>
                        <Avatar sx={{ bgcolor: "primary.light", color: "primary.contrastText" }}>
                            <EmojiEventsIcon />
                        </Avatar>
                    </ListItemAvatar>

                    <ListItemText
                        primary={qual.name}
                        primaryTypographyProps={{ fontWeight: 500 }}
                        secondary={`${qual.number_of_owners ?? 0} uczestników`}
                    />

                    <Chip
                        label={qual.number_of_owners ?? 0}
                        color="secondary"
                        size="small"
                    />
                </ListItem>
            ))}
        </List>
    );
}
